var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"images_list flex",style:({ 'justify-content': _vm.value.alignment })},[_c('picture',{directives:[{name:"full-image-path",rawName:"v-full-image-path",value:(_vm.value),expression:"value"}],staticClass:"flex",style:({ 'justify-content': 'center' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }